import Flexbox from "../../components/Flexbox";
import Mode from "../../components/styles/Mode";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import requests from "../../handlers/requests";
import '../../css/form.css'
import cookies from "../../utilities/Cookies";
import { updatedarkmode } from "../../features/mode";
import { useNavigate } from "react-router-dom";
import { BuyersTYUrl, extractUTMParameters, saveTrustedFormCert, tagContactSoftCredPull } from "../../utilities/utils";
import ProgressWithStatuses from "../../components/ProgressForResults";

const LoadingPage = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [loading,] = useState(true)

    const [, setError] = useState(null)

    const getParameters = () => {
        const urlParams = new URLSearchParams(window.location.search)
        // const contact_id = urlParams.get('contact_id')
        const email = urlParams.get('email')
        const phone = urlParams.get('phone')
        const dob = urlParams.get('dob')
        const street = urlParams.get('street')
        const city = urlParams.get('city')
        const zipcode = urlParams.get('zipcode')
        const amount = urlParams.get('amount')
        const contact_id = urlParams.get('contact_id')
        const page = urlParams.get('page')
        const first_name = urlParams.get('first_name')
        const last_name = urlParams.get('last_name')
        const tcert = urlParams.get('trusted_form_cert_url')

        return { email, phone, dob, street, city, zipcode, amount, contact_id, page, first_name, last_name, tcert }
    }

    const softCreditPull = async () => {
        const { email, phone, dob, street, city, zipcode, contact_id } = getParameters()

        // tag contact soft credit pull 1
        await tagContactSoftCredPull(contact_id, 1)

        if (email.includes('@') && email !== '') {
            if (phone) {
                if (dob && street && city && zipcode) {
                    requests.get(`/api/retell/v3/product-offer?email=${email}&phone=${phone}&dob=${dob}&address=${street}&city=${city}&zipcode=${zipcode}`, () => { }, () => { }, setError, () => { },
                        (res) => {
                            const { page, amount } = getParameters()

                            // if sent to turbo
                            if (res.url) {
                                const user = res.data
                                const ty_page = BuyersTYUrl.get(res.buyer).replaceAll('-valid', '') // https://www.finaldebt.com/success-valid-[buyer]- = https://www.finaldebt.com/success-[buyer]- |  https://www.finaldebt.com/success-[buyer]-

                                const full_url = `${ty_page}${page}1?first_name=${user.first_name}&last_name=${user.last_name}&debt_amount=${user.debt_amount}&phone=${user.phone}&email=${user.email}&zip=${user.zipcode}&url=${res.url ?? ''}${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid'])}`

                                // send to buyer's thank you page
                                return window.location.replace(full_url)
                            }

                            // check if server responded with buyer (Either False Buyer or frozen credit report)
                            if (res.buyer) {
                                if (res.buyer === 'frozen credit report') {
                                    goToFailedSoftCreditPullPage()
                                } else {
                                    const { page, amount } = getParameters()
                                    let url = page ? `https://www.finaldebtrelief.com/ddq-${page}` : `https://www.finaldebtrelief.com/ddq-lf`
                                    window.location.replace(`${url}?email=${email}&phone=${phone}&amount=${amount}&contact_id=${contact_id}&${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid', 'first_name', 'last_name', 'page', 'trusted_form_cert_url'])}`)
                                }
                            } else {

                                // check is response has data.buyer
                                if (res.data?.buyer !== null) {
                                    // go to dynamic buyers page
                                    goToDynamicBuyersPage(contact_id, amount, res.data?.buyer)
                                } else {
                                    if (res.data.ndr_error && res.data.ndr_error === "outside coverage")
                                        gotoDqPage()
                                    else
                                        goToResultPage(contact_id, amount) // go to results page
                                }

                            }

                        },
                        null,
                        (res) => {
                            if (res.source)
                                return goToDupPage() // source means error's from Turbo

                            goToFallbackForm(res.msg)
                        }
                    )
                } else {
                    goToFallbackForm('One or more information not provided!')
                }
            } else {
                console.log(phone)
                goToFallbackForm('Invalid phone number!')
            }
        } else {
            goToFallbackForm('Invalid email address!')
        }
    }

    const goToFallbackForm = (error) => {
        const { email, phone, dob, street, city, zipcode, amount, contact_id, first_name, last_name, page } = getParameters()

        navigate(`/fallback-form?first_name=${first_name}&last_name=${last_name}&email=${email}&phone=${phone}&dob=${dob}&street=${street}&city=${city}&zipcode=${zipcode}&amount=${amount}&page=${page}&error=${error}&contact_id=${contact_id}&${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid', 'first_name', 'last_name', 'page', 'trusted_form_cert_url'])}`, { replace: true })
    }

    const goToDupPage = () => {
        const { page, email, phone, amount, contact_id } = getParameters()

        // If Turbo fails, send lead to results page so V3 - Retell 1.0 is triggered and they are sent to NDR
        // goToResultPage(contact_id, amount)

        // Code below sends users to Turbo Dup page
        window.location.replace(`https://www.finaldebtrelief.com/dup-error-${page}?email=${email}&phone=${phone}&amount=${amount}&contact_id=${contact_id}&${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid', 'first_name', 'last_name', 'page', 'trusted_form_cert_url'])}`)
    }

    const gotoDqPage = () => {
        const { page, email, phone, amount, contact_id } = getParameters()

        // Code below sends users to dq page
        window.location.replace(`https://www.finaldebtrelief.com/dq-${page}?email=${email}&phone=${phone}&amount=${amount}&contact_id=${contact_id}&${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid', 'first_name', 'last_name', 'page', 'trusted_form_cert_url'])}`)
    }

    const goToResultPage = (contact_id, amount) => {
        const { email, phone, first_name, last_name } = getParameters()

        if (!isNaN(amount))
            if (parseFloat(amount) > 20_000)
                window.location.replace(`https://www.finaldebtrelief.com/over20-result-re1?email=${email}&phone=${phone}&amount=${amount}&contact_id=${contact_id}&first_name=${first_name}&last_name=${last_name}${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid', 'first_name', 'last_name', 'page', 'trusted_form_cert_url'])}`)
            else
                window.location.replace(`https://www.finaldebtrelief.com/under20-result-re1?email=${email}&phone=${phone}&amount=${amount}&contact_id=${contact_id}&first_name=${first_name}&last_name=${last_name}${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid', 'first_name', 'last_name', 'page', 'trusted_form_cert_url'])}`)
        else
            window.location.replace(`https://www.finaldebtrelief.com/over20-result-re1?email=${email}&phone=${phone}&amount=${amount}&contact_id=${contact_id}&first_name=${first_name}&last_name=${last_name}${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid', 'first_name', 'last_name', 'page', 'trusted_form_cert_url'])}`)
    }

    const goToDynamicBuyersPage = (contact_id, amount, buyer) => {
        const { email, phone, first_name, last_name } = getParameters()

        if (!isNaN(amount))
            if (parseFloat(amount) > 20_000)
                window.location.replace(`https://www.finaldebtrelief.com/over20-dbp1?email=${email}&phone=${phone}&amount=${amount}&contact_id=${contact_id}&first_name=${first_name}&last_name=${last_name}&buyer=${buyer}${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid', 'first_name', 'last_name', 'page', 'trusted_form_cert_url'])}`)
            else
                window.location.replace(`https://www.finaldebtrelief.com/under20-dbp1?email=${email}&phone=${phone}&amount=${amount}&contact_id=${contact_id}&first_name=${first_name}&last_name=${last_name}&buyer=${buyer}${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid', 'first_name', 'last_name', 'page', 'trusted_form_cert_url'])}`)
        else
            window.location.replace(`https://www.finaldebtrelief.com/over20-dbp1?email=${email}&phone=${phone}&amount=${amount}&contact_id=${contact_id}&first_name=${first_name}&last_name=${last_name}&buyer=${buyer}${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid', 'first_name', 'last_name', 'page', 'trusted_form_cert_url'])}`)
    }

    const performDataLayer = () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "Add_to_cart",
            url: window.location.href
        });
    }

    const goToFailedSoftCreditPullPage = () => {
        const { email, phone, amount, contact_id } = getParameters()

        window.location.replace(`https://www.finaldebtrelief.com/no-cred-re1?email=${email}&phone=${phone}&amount=${amount}&contact_id=${contact_id}${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid', 'first_name', 'last_name', 'page', 'trusted_form_cert_url'])}`)
    }

    useEffect(() => {
        cookies.setCookies('mode', 'light', 10)
        dispatch(updatedarkmode({ dark: false }))

        performDataLayer()
        softCreditPull()
        const { tcert, contact_id } = getParameters()
        saveTrustedFormCert(tcert, contact_id)
        // eslint-disable-next-line
    }, [])

    return (
        <Mode>
            <div className="retell-v3-loading-page">
                {loading && (
                    <div>
                        <Flexbox justifyContent="center" alignItems="center" style={{ height: '90dvh', width: '100%' }}>
                            <ProgressWithStatuses timer={15_000} onComplete={() => {
                                console.log('Done')
                            }} />
                        </Flexbox>
                    </div>
                )}
            </div>
        </Mode>
    );
}

export default LoadingPage;